import React, { useState, useEffect } from 'react';
import { ChevronUp } from 'lucide-react';

const BackToTop = () => {
  const [isVisible, setIsVisible] = useState(false);

  // eslint-disable-next-line react-hooks/exhaustive-deps -- mount-only scroll listener; setIsVisible is stable
  useEffect(() => {
    const toggleVisibility = () => {
      if (window.pageYOffset > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener('scroll', toggleVisibility);

    return () => window.removeEventListener('scroll', toggleVisibility);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  return (
    <>
      {isVisible && (
        <button
          onClick={scrollToTop}
          className="fixed bottom-6 right-6 z-40 w-8 h-8 bg-gray-900 text-white rounded-full flex items-center justify-center opacity-60 hover:opacity-100 transition-opacity duration-200 shadow-lg"
          aria-label="Back to top"
        >
          <ChevronUp size={16} />
        </button>
      )}
    </>
  );
};

export default BackToTop;
